import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 47px;\n\n  &,\n  .ant-btn {\n    color: ",
        ";\n\n    &[disabled] {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 44px;\n  margin: 0 8px;\n  border: none;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: -0.16px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import styled from "styled-components";
import Icon from "../icon/Icon";
import { Minus2, Plus2 } from "../icon/IconList";
import NoPadButton from "./Button/NoPadButton";
const RoundedCounterContainer = styled.div.withConfig({
    componentId: "sc-8e868426-0"
})(_templateObject(), (props)=>props.theme.new.colors.white, (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_900, (props)=>props.theme.new.colors.sol_gray_300);
const RoundedCounterNumber = styled.input.withConfig({
    componentId: "sc-8e868426-1"
})(_templateObject1());
const RoundedCounter = (param)=>{
    let { max =99 , value , onChange  } = param;
    const handleDecr = useCallback(()=>{
        onChange(value - (value <= 1 ? 0 : 1));
    }, [
        onChange,
        value
    ]);
    const handleIncr = useCallback(()=>{
        onChange(value + (value >= max ? 0 : 1));
    }, [
        onChange,
        value
    ]);
    const handleChange = useCallback(()=>{}, []);
    return /*#__PURE__*/ _jsxs(RoundedCounterContainer, {
        className: "rounded-counter",
        children: [
            /*#__PURE__*/ _jsx(NoPadButton, {
                type: "text",
                disabled: value <= 1,
                onClick: handleDecr,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: Minus2
                })
            }),
            /*#__PURE__*/ _jsx(RoundedCounterNumber, {
                value: value,
                onChange: handleChange
            }),
            /*#__PURE__*/ _jsx(NoPadButton, {
                type: "text",
                disabled: value >= max,
                onClick: handleIncr,
                children: /*#__PURE__*/ _jsx(Icon, {
                    icon: Plus2
                })
            })
        ]
    });
};
export default RoundedCounter;
